import { render, staticRenderFns } from "./Message-notification.vue?vue&type=template&id=230319f4&scoped=true&"
import script from "./Message-notification.vue?vue&type=script&lang=js&"
export * from "./Message-notification.vue?vue&type=script&lang=js&"
import style0 from "./Message-notification.vue?vue&type=style&index=0&id=230319f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230319f4",
  null
  
)

export default component.exports